// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const DepartmentsService = {
    ListDepartments(fn, req) {
        return fn(`/phone-exp/departments/v1/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateDepartment(fn, req) {
        return fn(`/phone-exp/departments/v1/update-dept`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ReadTimezone(fn, req) {
        return fn(`/phone-exp/departments/v1/timezone?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateVMO(fn, req) {
        return fn(`/phone-exp/departments/v1/update-vmo`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetVMO(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v1/get-vmo/department/${req["departmentId"]}?${fm.renderURLSearchParams(req, ["departmentId"])}`, { method: "GET" });
    },
    CreateDepartment(fn, req) {
        return fn(`/phone-exp/departments/v1/create-department`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    PhoneNumbers(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v1/department/${req["departmentId"]}/phone-numbers?${fm.renderURLSearchParams(req, ["departmentId"])}`, { method: "GET" });
    },
    ListPhoneNumbers(fn, req) {
        return fn(`/phone-exp/departments/v1/department/phone-numbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListValidSMSNumbers(fn, req) {
        return fn(`/phone-exp/departments/v1/valid-sms-numbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    AddPhoneNumbers(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v1/${req["departmentId"]}/add-phone-numbers`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteDepartment(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v1/delete/${req["departmentId"]}?${fm.renderURLSearchParams(req, ["departmentId"])}`, { method: "DELETE" });
    },
    RemovePhoneNumber(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
            fm.validateUrlParam(req["phoneNumberId"], "phoneNumberId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v1/${req["departmentId"]}/phone-number/${req["phoneNumberId"]}?${fm.renderURLSearchParams(req, ["departmentId", "phoneNumberId"])}`, { method: "DELETE" });
    },
    UpdatePhoneNumber(fn, req) {
        return fn(`/phone-exp/departments/v1/phone-number`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * This endpoint first remove phone number and then update other phone number.
     */
    UpdateAndRemovePhoneNumbers(fn, req) {
        return fn(`/phone-exp/departments/v1/update-remove-phone-numbers`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ReadDepartment(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v1/read/${req["departmentId"]}?${fm.renderURLSearchParams(req, ["departmentId"])}`, { method: "GET" });
    },
    /**
     * Return voicemail count for all departments under a location
     */
    DepartmentsVoicemailCount(fn, req) {
        return fn(`/phone-exp/departments/v1/voicemail_count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
